export default angular.module('eventix.common.services.elasticLoader',[])
    .factory('ElasticLoader', function($http, $q, $location, Order, UIMessages, User, $rootScope) {
        var ElasticLoader = {};
        var cache = {
            company: false,
            insightCompany: false,
            shop: false,
            event: false
        };

        $rootScope.$on('clearCache', () => {
            ElasticLoader.clearCache();
        });

        var asCompany = false;
        function checkAdminPriviledges() {
            if($location.search().as)
                asCompany = $location.search().as;
            else
                asCompany = false;
        }
        checkAdminPriviledges();

        ElasticLoader.getCompany = function(filter = 'paid') {
            if(cache.company)
                return $q.resolve(cache.company);
            checkAdminPriviledges();
            let companyId = (asCompany !== false ? asCompany : _.get(User.cached, 'me.company_id'));
            if(!companyId) return $q.reject('Missing company id, are you logged in?');
            return $http.get(`/statistics/company/${filter}/${companyId}`).then(response => {
                //return $http.get(`//dashboard.eventix/orders.json`).then(response => {
                let orders = response.data.hits.hits;
                if( response.data.hits.total < 1 )
                    return [Order.new(orders._source)];
                cache.company = _.map(orders, o => Order.new(o._source));
                return cache.company;
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        ElasticLoader.getOrders = function(data) {
            checkAdminPriviledges();
            let companyId = (asCompany !== false ? asCompany : _.get(User.cached, 'me.company_id'));
            if(!companyId) return $q.reject('Missing company id, are you logged in?');
            return $http.post(`/statistics/orders/${companyId}`, data).then(response => {
                return response;
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        ElasticLoader.search = function(data) {
            return $http.post('/statistics/search', data).then(response => {
                return response;
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        ElasticLoader.getOrderTickets = function(data) {
            checkAdminPriviledges();
            let companyId = (asCompany !== false ? asCompany : _.get(User.cached, 'me.company_id'));
            if(!companyId) return $q.reject('Missing company id, are you logged in?');
            return $http.post(`/statistics/tickets/${companyId}`, data).then(response => {
                return response;
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        ElasticLoader.clearCache = function() {
            _.keys(cache).forEach(k => cache[k] = false);
        };

        ElasticLoader.getShop = function(shopId) {
            if(!shopId) return $q.reject('invalid shopId');
            return $http.get(`/statistics/shop/${shopId}`).then(response => {
                let orders = response.data.hits.hits;
                if( response.data.hits.total < 1 )
                    return [Order.new(orders._source)];
                return _.map(orders, o => Order.new(o._source));
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        ElasticLoader.getEvent = function(eventId) {
            if(!eventId) return $q.reject('invalid eventId');
            return $http.get(`/statistics/event/${eventId}`).then(response => {
                let orders = response.data.hits.hits;
                if( response.data.hits.total < 1 )
                    return [Order.new(orders._source)];
                return _.map(orders, o => Order.new(o._source));
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        ElasticLoader.getHome = function() {
            checkAdminPriviledges();
            let companyId = (asCompany !== false ? asCompany : _.get(User.cached, 'me.company_id'));
            if(!companyId) return $q.reject('invalid companyId');
            return $http.get(`/statistics/home/${companyId}`).then(response => {
                return response.data.aggregations;
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        ElasticLoader.getTrackers = function() {
            checkAdminPriviledges();
            let companyId = (asCompany !== false ? asCompany : _.get(User.cached, 'me.company_id'));
            if(!companyId) return $q.reject('invalid companyId');
            return $http.get(`/statistics/trackers/${companyId}`).then(response => {
                return _.get(response,'data.aggregations', {});
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        ElasticLoader.getDashboard = function(eventId) {
            if(!eventId) return $q.reject('invalid eventId');
            return $http.get(`/statistics/dashboard/${eventId}`).then(response => {
                return response.data.aggregations;
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        ElasticLoader.getInsights = function() {
            if(cache.insightCompany)
                return $q.resolve(cache.insightCompany);
            checkAdminPriviledges();
            let companyId = (asCompany !== false ? asCompany : _.get(User.cached, 'me.company_id'));
            if(!companyId) return $q.reject('Missing company id, are you logged in?');
            return $http.get(`/statistics/insights/${companyId}`).then(response => {
            //return $http.get(`//dashboard.eventix/orders.json`).then(response => {
                let orders = response.data.hits.hits;
                if( response.data.hits.total < 1 )
                    return [Order.new(orders._source)];
                cache.insightCompany = _.map(orders, o => Order.new(o._source));
                return cache.insightCompany;
            }, error => {
                UIMessages.push('common.notice.error');
                throw error;
            });
        };

        /**
         * Get advanced statistics, aggregates sales and revenue over time, for specific timeperiods, optionally filtered by metadata
         *
         * @param {Object} datasetConfig Configuration object for the dataset to fetch
         * ```
         * // Dataset configuration
         * {
         *  event: {Event},           // Event to search for
         *  tickets: {Array<Ticket>}, // Tickets to search for
         *  includeFree: {Boolean},   // Include free tickets in search
         *  giveAll: {Boolean}        // Admin-only - search all tickets instead of just selection of tickets
         *  start: 'YYYY-MM-DD',      // Left time-boundary
         *  end: 'YYYY-MM-DD',        // Right time-boundary
         *  timeunit: {String},       // Timeunit to aggregate sales for (hour, day, week or month)
         *  filters: {Array<Object>}  // Array of filters
         * }
         * // Filter configuration
         * {
         *  type: {String},          // Type of filter (geo, tracker or metadata)
         *  key: {String|Null},      // Required for metadata en geo types. Key holds the `metadata_guid` or the GoogleMaps attribute (i.e.: locality, country_code)
         *  level: {String},         // Required for metadata en geo types, whether to apply the filter on 'order' or 'ticket' level
         *  values: {Array<String>}, // Filter for these values, required when query is not present
         *  query: {String}          // Filter for this custom query
         *  // when both query and value are absent, filter is ignored
         * }
         * ```
         * @param {Filter} aggregateFilter A filter to aggregate by, to determine possible buckets
         * When exploring the possible buckets within a filter, pass the filter as second parameter and we'll return some statistics on it.
         * @return {Promise<Object>} Resolves when data is fetched
         */
        ElasticLoader.getAdvancedStatistics = function(datasetConfig, aggregateFilter) {
            checkAdminPriviledges();
            let companyId = (asCompany !== false ? asCompany : _.get(User.cached, 'me.company_id'));
            if(!companyId) return $q.reject('Missing company id, are you logged in?');
            var request = {
                give_all: _.get(datasetConfig, 'giveAll', false),
                company_id: companyId,
                event_id: _.get(datasetConfig, 'event.guid', datasetConfig.event_id),
                tickets: _.map(datasetConfig.tickets, t => angular.isString(t) ? t : t.guid),
                start: datasetConfig.start,
                end: datasetConfig.end,
                timeunit: datasetConfig.timeunit,
                include_free: datasetConfig.includeFree || false,
                aggregate_trackers: _.get(datasetConfig, 'aggregate_trackers', false),
                aggregate_geo: _.get(datasetConfig, 'aggregate_geo', false),
                aggregate_metadata_for: _.get(datasetConfig, 'aggregate_metadata_for', []),
                tracker_filters: '',
                geo_order_filters: {},
                geo_ticket_filters: {},
                order_filters: {},
                ticket_filters: {}
            };
            if(aggregateFilter) {
                switch(aggregateFilter.type) {
                    case 'geo':
                        request.aggregate_geo = true;
                        break;
                    case 'metadata':
                        request.aggregate_metadata_for.push(aggregateFilter.key);
                        break;
                    default:
                    case 'trackers':
                        request.aggregate_trackers = true;
                        break;
                }
            }
            _.forEach(datasetConfig.filters, filter => {
                if(!filter || (!(filter.query && filter.query.length) && !(filter.values && filter.values.length)))
                    return;
                switch(filter.type) {
                    case 'geo':
                        request['geo_' + filter.level + '_filters'][filter.key] = filter.query || _.join(filter.values, ' OR ');
                        break;
                    case 'metadata':
                        request[filter.level + '_filters'][filter.key] = filter.query || _.join(filter.values, ' OR ');
                        break;
                    default:
                    case 'trackers':
                        request.tracker_filters = filter.query || _.join(filter.values, ' OR ');
                        break;
                }
            });
            return $http.post('/statistics/advanced', request).then(response => {
                if(response.statusCode >= 400 || !_.has(response, 'data.aggregations'))
                    return $q.reject(response);
                if(aggregateFilter)
                    return _.get(response, 'data.aggregations', {});
                return _.get(response, ['data','aggregations','stats', request.event_id], {});
            });
        };

        /**
         * Discover possible buckets for a filter
         *
         * SIDE EFFECT: Will set the `level` attribute on the filter to correspond to the largest dataset on geo and metadata filters
         *
         * @param {Object} datasetConfig Configuration object for the dataset to fetch
         * ```
         * // Dataset configuration
         * {
         *  event: {Event},           // Event to search for
         *  tickets: {Array<Ticket>}, // Tickets to search for
         *  includeFree: {Boolean},   // Include free tickets in search
         *  giveAll: {Boolean}        // Admin-only - search all tickets instead of just selection of tickets
         *  start: 'YYYY-MM-DD',      // Left time-boundary
         *  end: 'YYYY-MM-DD',        // Right time-boundary
         *  timeunit: {String},       // Timeunit to aggregate sales for (hour, day, week or month)
         *  filters: {Array<Object>}  // Array of filters
         * }
         * // Filter configuration
         * {
         *  type: {String},          // Type of filter (geo, tracker or metadata)
         *  key: {String|Null},      // Required for metadata en geo types. Key holds the `metadata_guid` or the GoogleMaps attribute (i.e.: locality, country_code)
         *  level: {String},         // Required for metadata en geo types, whether to apply the filter on 'order' or 'ticket' level
         *  values: {Array<String>}, // Filter for these values, required when query is not present
         *  query: {String}          // Filter for this custom query
         *  // when both query and value are absent, filter is ignored
         * }
         * ```
         * @param {Filter} filter A filter to aggregate by, to determine possible buckets
         * When exploring the possible buckets within a filter, pass the filter as second parameter and we'll return some statistics on it.
         * @return {Promise<Array>} Resolves with a set of possible buckets `{key, doc_count}`
         */
        ElasticLoader.getAdvancedFilterOptions = function(datasetConfig, filter) {
            checkAdminPriviledges();
            let companyId = (asCompany !== false ? asCompany : _.get(User.cached, 'me.company_id'));
            if(!companyId) return $q.reject('Missing company id, are you logged in?');

            datasetConfig = _.cloneDeep(datasetConfig);

            _.each(datasetConfig.filters, (datasetFilter) => {
                if (datasetFilter.id === filter.id) {
                    datasetFilter.values = [];

                    return false;
                }
            });

            return this.getAdvancedStatistics(datasetConfig, filter, 'aggregations').then(data => {
                var docsOrderLevel, docsTicketLevel;
                switch(filter.type) {
                    case 'metadata':
                        docsOrderLevel = _.get(data,  'orderMetaData.doc_count', 0);
                        docsTicketLevel = _.get(data, 'ticketMetaData.doc_count', 0);
                        if(docsOrderLevel > docsTicketLevel) {
                            data = data.orderMetaData[filter.key].statistics.buckets;
                            filter.level = 'order';
                        } else {
                            data = data.ticketMetaData[filter.key].statistics.buckets;
                            filter.level = 'ticket';
                        }
                        break;
                    case 'geo':
                        docsOrderLevel = _.get(data, 'geo_orders.doc_count', 0);
                        docsTicketLevel = _.get(data, 'geo_tickets.doc_count', 0);
                        if(docsOrderLevel > docsTicketLevel) {
                            data = data.geo_orders[filter.key].buckets;
                            filter.level = 'order';
                        } else {
                            data = data.geo_tickets[filter.key].buckets;
                            filter.level = 'ticket';
                        }
                        break;
                    default:
                    case 'trackers':
                        data = data.trackers.trackers.trackers.buckets;
                        break;
                }
                return data;
            });
        };

        return ElasticLoader;
    }).name;
